import ajax from "@/lib/ajax/index";
import { uniqueId } from "@/views/zhiji/js/common/util";

const sourceMap = ["客户端参数", "API参数", "数据平台清洗参数", "自定义参数"];
const typeMap = {
    string: "文本类",
    datetime: "日期类",
    float: "数值类",
    bool: "判断类"
};

// 请求画像参数表格数据
export async function queryParamsList(reqData) {
    const params = {
        game_id: reqData.gameId,
        page: reqData.page || 1,
        size: reqData.size || 10
    };
    if (reqData.param_search) {
        params.search_type = reqData.param_search.type;
        params.search_field = reqData.param_search.keyWord;
    }
    if (reqData.source) {
        params.source = reqData.source.join();
    }
    const { count, list } = await ajax.get("/xiaoyue-operation/user_profile/param/search", params);
    return {
        count,
        list: list.map(item => {
            return {
                ...item,
                sourceName: sourceMap[item.source],
                typeName: typeMap[item.type],
                Operation: [
                    {
                        label: "删除",
                        value: "del"
                    }
                ],
            }
        })
    };
}

// 获取客户端参数配置数据
export async function queryConfigParams(reqData) {
    const { count, list = [] } = await ajax.get("/xiaoyue-operation/user_profile/param/getConf", {
        game_id: reqData.gameId,
        source: reqData.source,
    });
    return {
        count,
        list: list.map(item => {
            return {
                ...item,
                id: uniqueId(),
                disabled: item.is_enable,
            }
        }),
    };
}

// 添加画像参数
export async function addParams(reqData) {
    const params = {
        game_id: reqData.gameId,
        params: JSON.stringify(reqData.params),
    };
    const { success_total: successTotal } = await ajax.post("/xiaoyue-operation/user_profile/param/add", params);
    return successTotal;
}

// 判断参数是否在标签使用中
export async function isReference(reqData) {
    const params = {
        game_id: reqData.gameId,
        ids: reqData.ids
    };
    const { reference_param_ids: referenceParamIds } = await ajax.get("/xiaoyue-operation/user_profile/param/isReference", params);
    return referenceParamIds;
}

// 删除画像参数
export async function delParams(reqData) {
    const params = {
        game_id: reqData.gameId,
        ids: reqData.ids
    };
    const { result = [] } = await ajax.post("/xiaoyue-operation/user_profile/param/delete", params);
    return result;
}

// 编辑画像参数
export async function editParams(reqData) {
    const params = {
        game_id: reqData.gameId,
        id: reqData.id,
        name: reqData.name,
        describe: reqData.describe,
        type: reqData.type,
        table_name: reqData.table_name || "",
        source: reqData.source,
        source_value: reqData.sourceValue || "",
        remark: reqData.remark || "",
    };
    const result = await ajax.post("/xiaoyue-operation/user_profile/param/update", params);
    return result;
}